import { basicInitialState } from '../_utils/basicInitialState';
import { TFleetsState } from './fleetsModel';

export const fleetsInitialState: TFleetsState = {
  ...basicInitialState,
  fleets: []
};
